// extracted by mini-css-extract-plugin
export default {"TipOne":"TipOne_TipOne__wR8jo"};